import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "../Modal.scss";
import "./QuoteProjectModal.scss";
import QuoteProjectForm from "../../Form";

const QuoteProjectModal = ({ isOpen, onClose }) => {
    const [isAnimating, setIsAnimating] = useState(false); // Zarządza animacją zamykania
    const modalRoot = document.getElementById("project-quote-modal");

    if (!modalRoot) return null;

    const handleClose = () => {
        setIsAnimating(true); // Uruchamia animację zamykania
        setTimeout(() => {
            setIsAnimating(false);
            onClose(); // Wywołuje funkcję zamykającą po zakończeniu animacji
        }, 400); // Czas trwania animacji
    };

    useEffect(() => {
        if (!isOpen) {
            setIsAnimating(false); // Resetuje stan animacji, jeśli modal nie jest otwarty
        }
    }, [isOpen]);

    return ReactDOM.createPortal(
        <div className={`modal ${isOpen ? "open" : ""} ${isAnimating ? "closing" : ""}`}>
            {/*<div className="modal-overlay" onClick={handleClose}></div>*/}
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={handleClose}></button>
                <QuoteProjectForm onFormSuccess={handleClose}/>
            </div>
        </div>,
        modalRoot
    );
};

export default QuoteProjectModal;
